<template>
  <div class="notification" :class="[{ _warning: warning }, modify]">
    <icon :name="icon" class="notification__main-icon" />
    <span class="notification__text"><slot /></span>
    <icon name="warning" v-if="warning && !clickable" />
  </div>
</template>

<script>
export default {
  name: "Notification",

  props: {
    warning: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: "calendar"
    },

    modify: {
      type: String,
      default: ""
    },
    clickable: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/media";
.notification {
  background-color: #f0f5f9;
  padding: 15px 20px;

  position: relative;

  @include respond-down(md) {
    font-size: 12px;
  }

  &__main-icon {
    width: 16px;
    height: 16px;
    min-width: 16px;
    margin-right: 8px;
    &.clickable {
      cursor: pointer;
    }
  }

  .svg-icon--warning {
    position: absolute;
    top: 14px;
    right: 15px;
    width: 16px;
    height: 16px;
    @include respond-down(lg) {
      right: 10px;
    }
    @include respond-down(md) {
      right: 40px;
    }
  }

  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #6d7179;

  &__text {
    position: relative;
    top: -2px;
    max-width: 95%;
    ._flex & {
      flex: 1;
    }
  }

  &._warning {
    background: rgba(246, 147, 29, 0.1);
    color: #f6931d;
  }
  &._flex {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
